export default "__VITE_ASSET__rcm8iQJ2__"